export default {"src":"/_next/static/media/circleList.a84631aa.svg","height":99,"width":76};